import React from "react";
import Props from "../../models/Properties"
import PropItem from "./PropItem"
import { Accordion, Button } from 'react-bootstrap';
import { useLanguage } from "pages/dimension/LanguageContext";

const PropsGroup: React.FC<{ groupProp: any, doSave: (params: any)=>Promise<any>}> = (props) => {
    const [message, setMessage] = React.useState<string | null>(null);
    const [modified, setModified] = React.useState(false);
    const langCtx = useLanguage();
    
    function onPropertyChange(prop: any, value: any) {
        //console.log(`Property changed ${prop.path} = ${value}`);
        Props.updateValue(prop, value);
        setModified(Props.checkModified(props.groupProp));
        setMessage(null);
    }

    function saveClickHandler() {
        if (!modified) {
            return;
        }
        let mods = Props.listModified(props.groupProp.items);
        let flatten = mods.map((item: any) => { return {path: item.path, value: item.serialize(item.newValue)}});
        setMessage("Saving your changes..");
        props.doSave(Props.serialize(flatten)).then((res: any)=> {
            //if (res && res.ok == 1) {
                console.log(`Properties successfuly updated.`)
                Props.markUnmodified(mods);
                setModified(false);
                setMessage("Changes saved.");
            //} else {
            //    console.error(`Failed to update properties: ${JSON.stringify(res)}`);
            //    setMessage("Something went wrong during the update. Your changes could be lost.");
            //}
        }).catch((e: string)=> {
            console.error(`Failed to update properties: ${e}`);
            setMessage("Failed to update properties.");
        });
    }

    return (
        <Accordion defaultActiveKey="0" alwaysOpen flush>
            {props.groupProp._group.hide !== true
                ? <Accordion.Item eventKey="0">
                    {props.groupProp._group.title ? <Accordion.Header>{props.groupProp._group.title}</Accordion.Header> : null}
                    <Accordion.Body className="d-flex flex-column">
                        {props.groupProp.items.map(
                                (item: any, i: number) => {
                                    return (<PropItem key={i} data={{prop: item, onChange: onPropertyChange/*props.data.onChange*/}}/>)
                                }
                        )}
                        {message && (<p><br/>{message}</p>)}
                        {modified && (
                            <Button variant="danger" style={{ flex: 1}} onClick={saveClickHandler}>{langCtx.translate('Save Changes')}</Button>
                        )}
                    </Accordion.Body>
                </Accordion.Item>
                : null
            }
        </Accordion>
    );
};

export default PropsGroup;
